import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import './ProgressBar.scss';


const ProgressBar = ({ currentSaving, totalSaving, classes }) => {
  const width = (+currentSaving / +totalSaving) * 100;
  return (
    <div className={cx('container1')}>
      <div className={cx('progressBarContainer')}>
        <div className={cx('progress', classes.progress)}>
          <div className={cx('bar', classes.bar)} style={{ width: `${width}%` }} />
        </div>
      </div>
    </div>
  );
  // }
};


ProgressBar.propTypes = {
  classes: PropTypes.string,
  totalSaving: PropTypes.number.isRequired,
  currentSaving: PropTypes.number.isRequired
};

ProgressBar.defaultProps = {
  classes: {},
};

export default (ProgressBar);
